import { AsyncField, Field, useFormContext } from '@oscar/form';
import { DatePicker } from '@oscar/theme';
import { Col, Icon, Input, Row, Select } from '@oscar/theme';
import { DatePickerPopulate, TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { debounce } from 'lodash';
import moment from 'moment';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import ListResult from './components/ListResult';

const { Option } = Select;

export const PaintingWorkDetail = ({
  statusRequest: { state, status },
}: {
  statusRequest: StatusInstance;
}) => {
  return (
    <div className="removal-detail">
      <Field name="paintingWorkDetail" noStyle>
        <ListResult />
      </Field>
      {state === 'EDIT' && (
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <AsyncField
              name={'fetchLeaderName'}
              requests={[
                {
                  name: 'leaderName',
                  url: APIS.REINSTATEMENT_SEARCH_LEADER_NAME,
                  method: 'GET',
                  nextParams: (nextProps: any) => {
                    return {
                      limit: 6,
                      name: nextProps?.customData?.textSearch || '',
                    };
                  },
                },
              ]}
            >
              {(leaderNameProps: any) => {
                const options = leaderNameProps?.data?.leaderName || [];
                const textSearch =
                  leaderNameProps?.requests?.[0]?.params?.name || '';
                return (
                  <>
                    <p className="label-normal">Work Leader Name</p>
                    <Field name={['workLeaderId']}>
                      <Select
                        value={textSearch}
                        showSearch
                        suffixIcon={<Icon icon="search" size={18} />}
                        className="select-search"
                        placeholder="Search for Name"
                        allowClear
                        filterOption={false}
                        onSearch={debounce(value => {
                          leaderNameProps.reloadData({ textSearch: value });
                        }, 300)}
                      >
                        {options.map?.((item: any) => {
                          return (
                            <Option value={item.id} key={item.id}>
                              {item?.name}
                            </Option>
                          );
                        })}
                      </Select>
                    </Field>
                  </>
                );
              }}
            </AsyncField>
          </Col>
          <Col span={12}>
            <p>Painting Completion</p>
            <Field name={['paintingCompletion']}>
              <DatePickerPopulate format={FORMAT_DATE.SHORT_MONTH_DATE} />
            </Field>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default PaintingWorkDetail;
